import React from "react";
import { Datagrid, TextField } from "react-admin";
import PbhNotesFiled from "../../../../../Components/ReferenceFields/Notes/PbhNotesFiled";
import { PbhRequestStatus } from "../../../../../Enums/PbhRequestStatus";
import DataGridActionsButtons from "./DataGridActionsButtons";
import WarehousePanel from "./WarehousePanel";
import PbhWhField from "../../../../../Components/WhFields/PbhWhField";
import { WarehouseType } from "../../../../../Enums/WarehouseType";
import RefNoField from "../../../../../../src/Components/ReferenceFields/RefNoField/RefNoField";
import { CustomDateField } from "../../../../../Components/CustomDateField";
import CopyableTableWrapper from "../../../../../../src/Components/CopyableTableWrapper";
export const PbhReserved = props => {
  const onEdit = (id, basePat, record) => {
    if (basePat == "/pbhrequestremarks/pbhrequestorders/") {
      props?.onCreateRemarks?.(record);
    } else {
      const win: any = window.open(`#/pbhrequestorders/${id}`, "_blank");
      win.focus();
    }
  };
  return (
    <CopyableTableWrapper>
      <Datagrid
        optimized
        {...props}
        classes={{ table: props.classes.datagrid }}
        hasBulkActions={false}
        expand={<WarehousePanel />}
      >
        <DataGridActionsButtons
          label={"Actions"}
          onEdit={onEdit}
          tabValue={PbhRequestStatus.Reserved}
          reloadTabs={props.reloadTabs}
        />
        <RefNoField label="REF NO" />
        <TextField source="customerName" label="CUSTOMER" sortable={false} />
        <TextField source="customerPo" label="CUSTOMER PO" />
        <TextField source="requirementCategoryText" label="REQUIREMENT CATEGORY" />
        <TextField source="pn" label="PN" />
        <TextField source="pnDescription" label="PN DESCRIPTION" />
        <TextField source="airportCode" label="DESTINATION" />
        <TextField source="acRegistration" label="AC" />
        <CustomDateField source="requestedDeliveryDate" label="REQUESTED DELIVERY DATE" showTime locales="en-GB" />
        <PbhWhField source="pn" whType={WarehouseType.Wh} label="Wh" />
        <PbhWhField source="pn" whType={WarehouseType.Res} label="Res" />
        <PbhWhField source="pn" whType={WarehouseType.AltPn} label="Alt. Pn" valueSource="count" />
        <PbhWhField source="pn" whType={WarehouseType.Rn} label="Rn" />
        <PbhNotesFiled label="PBH NOTE" />
        <TextField source="advancedXo" label="ADV XO" />
      </Datagrid>
    </CopyableTableWrapper>
  );
};

export default PbhReserved;
